// ============================================================
//  RESULTS PAGE — grey out fully-reserved apartments
// ============================================================
(function () {
  "use strict";

  function boot() {
    // ── FEATURE TOGGLE — same switch as the apartment page ──
    if (window.apartmentCartReserveEnabled === false) return;

    var cards = document.querySelectorAll(".single_destination_col[data-product-card]");
    if (!cards.length) return;

    var BACKEND = (
      window.apartmentBackendUrl ||
      "https://teal-camel-256853.hostingersite.com"
    ).replace(/\/+$/, "");

    var slotKeyMap = {};
    var cardSlotKeys = {};
    var slotKeys = [];

    cards.forEach(function (card) {
      var pid = card.getAttribute("data-product-id");
      var raw = card.getAttribute("data-cohort-variants") || "";
      if (!pid || !raw) return;

      raw.split(",").forEach(function (pair) {
        var parts = pair.split(":");
        if (parts.length !== 2) return;
        var vid = parts[1].trim();
        if (!vid) return;
        var key = pid + ":" + vid;
        slotKeys.push(key);
        slotKeyMap[key] = card;
        (cardSlotKeys[pid] = cardSlotKeys[pid] || []).push(key);
      });
    });

    if (!slotKeys.length) return;

    fetch(BACKEND + "/api/cart/reserve/check-batch", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slotKeys: slotKeys }),
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data.results) return;

        // Object.keys(cardSlotKeys).forEach(function (pid) {
        //   var keys = cardSlotKeys[pid];
        //   var card = slotKeyMap[keys[0]];
        //   if (!card) return;

        //   var held = keys.filter(function (k) {
        //     return data.results[k] && data.results[k].available === false;
        //   }).length;

        //   if (held > 0) {
        //     markReserved(card);
        //   }
        // });
        Object.keys(cardSlotKeys).forEach(function (pid) {
          var keys = cardSlotKeys[pid];
          var card = slotKeyMap[keys[0]];
          if (!card) return;

          var heldCount = keys.filter(function (k) {
            return data.results[k] && data.results[k].available === false;
          }).length;

          // Only mark the card as reserved when EVERY variant for this
          // product is currently held. Otherwise the user should still be
          // able to open the apartment and pick an available date.
          if (heldCount === keys.length && keys.length > 0) {
            markReserved(card);
          }
        });
      })
      .catch(function () {});
  }

  function markReserved(card) {
    if (card.hasAttribute("data-held-out")) return;
    card.setAttribute("data-held-out", "1");
    card.setAttribute("aria-disabled", "true");
    card.style.position = "relative";
    card.style.opacity = "0.55";
    card.style.filter = "grayscale(0.35)";
    card.style.pointerEvents = "none";

    var badge = document.createElement("span");
    badge.setAttribute("data-hold-badge", "reserved");
    badge.textContent = "Reserved";
    badge.style.cssText = [
      "position:absolute",
      "top:12px",
      "right:12px",
      "background:#3A3A3A",
      "color:#F5F1E8",
      "padding:6px 12px",
      "border-radius:100px",
      "font-size:12px",
      "letter-spacing:0.10em",
      "text-transform:uppercase",
      "font-family:inherit",
      "z-index:2",
      "pointer-events:none",
      "box-shadow:0 2px 8px rgba(0,0,0,.12)",
      "height:32px",
    ].join(";");
    card.appendChild(badge);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();